import React from 'react';
import ApiError from 'components/common/ApiError';
import Skeleton from 'react-loading-skeleton';
import { useComponentDetails } from 'hooks/useComponentDetails';
import { API_ENDPOINTS } from 'constants';
import InputList from 'components/common/InputList';
import DetailCard from 'components/list/DetailCard';

export const bankAccountItems = [
    { label: 'bank_accounts.label.account_holder', icon: 'person', key: 'account_holder', type: 'text' },
    { label: 'bank_accounts.label.iban', icon: 'money', key: 'iban', type: 'text' },
    { label: 'bank_accounts.label.bic', icon: 'money', key: 'bic', type: 'text' },
];

const BankAccountDetails = ({ selectedItem, list }) => {
    const { data, saveKey, isLoading, error, saveError, success, refetch, toolbar } =
        useComponentDetails(API_ENDPOINTS.BANK_ACCOUNTS.ITEM(selectedItem.id), list);
    
    const toolbarItems = [toolbar.back, toolbar.delete, toolbar.undelete];

    if (isLoading) return <Skeleton height={30} count={20} />;
    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message} />;

    return (
        <DetailCard toolbarItems={toolbarItems} success={success} saveError={saveError}>
            <InputList fields={bankAccountItems} data={data} onChange={saveKey} />
        </DetailCard>
    );
};

export default BankAccountDetails;
